module.exports = __webpack_public_path__ + "img/interactive-hero-slider-kia.6cd9d21c.png";